import { Col, Row, Form, Breadcrumb, Input, Select, Button, Tabs, Switch, DatePicker, Popover } from "antd";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { InfoCircleOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { createBillItem, editBillItem } from "../../api/bills";
import { useMutation } from "react-query";
import { Link } from "react-router-dom";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { getItemsDropDown } from "../../api/itemapi";
import { message } from "antd";
import { InputNumber } from "../UI/InputNumberComponent/inputnumber";
interface ItemInterface {
  barcode: string;
  quantity: number;
  price: number;
  tax: number;
  discount: number;
  notes: string;
}
interface options {
  value: number;
  label: string;
}

function AddEditBillItemBill() {
  const { state } = useLocation();
  const { categories = null, item = null, disabled, invoiceNo, bill } = state;
  const [t] = useTranslation("common");
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState<options[]>();
  const [isTaxable, setIsTaxable] = useState<boolean>(item?.isTaxable);
  // const [discount, setDiscount] = useState(bill?.discount ?? false);
  const { billId, itemId = false } = useParams();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const { TextArea } = Input;

  const [inputEnabled, setInputEnabled] = useState(false);
  const handleRadioChange = (checked: boolean) => {
    setInputEnabled(checked);
    setIsTaxable(checked);
  };
  const isEdit = () => {
    return !!itemId;
  };
  const [key, setKey] = useState("1");
  const onChange = (key: string) => {
    setKey(key);
  };
  const billTab = [
    {
      key: "1",
      label: `${t("general-information")}`,
    },
  ];
  const [, setError] = useState("");

  const onError = (error: any, variables: ItemInterface, context: unknown) => {
    if (setError) {
      setError(error.response.data.message);
      message.error({
        content: error.response.data.message,
        duration: 10,
        onClick: () => {
          message.destroy();
        },
      });
    }
  };
  const { mutateAsync: getItemsMutation, isLoading: isItemsLoading } =
    useMutation("getItemsByCat", (id: number) => getItemsDropDown(id));

  const { mutateAsync: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createBillItem" : "editBillItem",
    !isEdit()
      ? (Item: ItemInterface) => createBillItem(billId, Item)
      : (Item: ItemInterface) => editBillItem(billId, itemId, Item),
    {
      onSuccess: (res) => {
        navigate(`/itembill/${billId}`, {
          state: {
            disabled: disabled,
            invoiceNo: invoiceNo
          }
        });
      },
      onError,
    }
  );
  const HandleFinish = () => {
    const newBillItem = form.getFieldsValue();

    newBillItem.price = Number(newBillItem.price);
    const discount = Number(newBillItem.discount);
    newBillItem.discount = discount !== 0 ? discount : null;
    const tax = Number(newBillItem.tax);
    newBillItem.tax = tax !== 0 ? tax : null;
    const expirationDate = form.getFieldValue("expirationDate");

    if (expirationDate) {
      const formattedExpirationDate = formatDateWithTime(expirationDate);
      newBillItem.expirationDate = formattedExpirationDate;
    } else {
      newBillItem.expirationDate = null;
    }

    mutateCreateUpdate(newBillItem)
      .then(() => {
        message.success(
          isEdit() ? "Saved successfully!" : "Added successfully!"
        );
      })
      .catch((err) => {
        message.error(err?.response?.data?.errors[0]?.msg);
      });
  };
  function formatDateWithTime(dateValue: any) {
    const date = new Date(dateValue);
    if (!isNaN(date.getTime())) {
      const formattedDate = `${(date.getMonth() + 1)
        .toString()
        .padStart(2, "0")}/${date
          .getDate()
          .toString()
          .padStart(2, "0")}/${date.getFullYear()}`;

      // Add time components
      const time = `${date.getHours().toString().padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;

      return `${formattedDate} ${time}`;
    }
    return null; // Return null if the dateValue is invalid
  }

  useEffect(() => {
    form.setFieldsValue({
      categoryId: item ? item.item.category.name : categories[0].value,
      itemId: item?.item.id,
      price: item?.price,
      sales: item?.sales,
      expirationDate: item?.expirationDate ? dayjs(new Date(item?.expirationDate)) : "",
      quantity: item?.quantity,
      tax: item?.tax,
      isTaxable: item?.isTaxable,
      notes: item?.notes,
      discount: item?.discount ?? bill?.discount,
      discountType: item?.discountType ?? bill?.discountType
      // discount: item?.discount,
      // discountType: item?.discountType,
    });
  }, [item, form]);

  const handleChange = (checked: boolean) => {
    // setDiscount(checked);
  };
  interface Item {
    id: number;
    isActive: boolean;
    name: string;
  }
  useEffect(() => {
    getItemsMutation(item ? item.item.category.id : categories[0].value).then(
      (res) => {
        setItems(
          res.data.map((item: Item) => {
            return { value: item.id, label: item.name };
          })
        );
      }
    );
  }, []);

  const selectdiscount = (
    <Form.Item name="discountType" noStyle>
      <Select
        className="custom-select"
        style={{
          width: 100,
          // background: discount ? "white" : "transparent",
          border: "1px solid #d9d9d9",
          borderRadius: "6px",
          height: "100%",
        }}
        placeholder={`${t("enter-text")}`}
        options={[
          {
            value: "#",
            label: "#",
          },
          {
            value: "%",
            label: "%",
          },
        ]}
        disabled={bill?.discount}
      />
    </Form.Item>
  );

  const content = (
    <>
      <Col>
        {t("last-purchase")}&nbsp; :
        <span className="spancolor"> 0000 &nbsp;</span>
      </Col>
      <Col>
        {t("last-sales")}&nbsp; :
        <span className="spancolor"> 0000 &nbsp; </span>
      </Col>
      <Col>
        {t("last-profit")}&nbsp; :
        <span className="spancolor"> 00000 &nbsp;</span>
      </Col>
    </>
  );

  return (
    <>
      <Row>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("purchases")}</>,
              },
              { title: <>{t("bills-list")}</> },
              {
                title: (
                  <>
                    {" "}
                    {isEdit()
                      ? `${t("edit-bill-item")}`
                      : `${t("add-bill-item")}`}
                  </>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("general-information")}
                  </span>
                ),
              },
            ]}
          />
        </Col>

        {isEdit() && (
          <Col className="editTitle" offset={1} span={20}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <span style={{ marginRight: "5px" }}> {item.item.name} </span>
              <Popover content={content} trigger="click" placement="right">
                <Button type="text" className="Button">
                  <InfoCircleOutlined
                    style={{
                      color: "#1677FF",
                      fontSize: "20px",
                    }}
                  />
                </Button>
              </Popover>
            </div>
          </Col>
        )}
      </Row>
      <Row>
        <Col offset={1} span={22}>
          <Tabs
            className="ant-tab"
            defaultActiveKey="1"
            activeKey={key}
            items={billTab}
            onChange={onChange}
          />
        </Col>
      </Row>
      <Form
        layout="vertical"
        form={form}
        onFinish={HandleFinish}
        id="itembillform"
      >
        <Row style={{ minHeight: "60vh" }}>
          <Col offset={1} span={5}>
            <Form.Item
              name="categoryId"
              label={`${t("category")}`}
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                showSearch={true}
                optionFilterProp="label"
                placeholder={`${t("select-item")}`}
                options={categories}
                defaultValue={item ? item.item.category.id : categories[0].id}
                disabled={isEdit()}
                onChange={(value) => {
                  form.setFieldsValue({ itemId: undefined });
                  getItemsMutation(value).then((res) => {
                    setItems(
                      res.data.map((item: Item) => {
                        return { value: item.id, label: item.name };
                      })
                    );
                  });
                }}
              />
            </Form.Item>

            <Form.Item
              name="itemId"
              label={`${t("item")}`}
              rules={[
                {
                  required: true,
                  message: "item is requried",
                },
              ]}
            >
              <Select
                showSearch={true}
                optionFilterProp="label"
                placeholder={`${t("select-item")}`}
                options={items}
                disabled={isEdit()}
                loading={isItemsLoading}
              />
            </Form.Item>
            <Form.Item
              name="quantity"
              label={`${t("quantity")}`}
              rules={[{ required: true, message: "quantity is requried" }]}
            >
              <InputNumber maxLength={10} />
            </Form.Item>
            <Form.Item
              name="price"
              label={`${t("purchase-price")}`}
              rules={[
                {
                  required: true,
                  message: "purchase price is requried",
                },
              ]}
            >
              <Input
                placeholder={`${t("enter-text")}`}
                autoComplete="off"
                maxLength={15}
              />
            </Form.Item>
            <Form.Item
              name="sales"
              label={`${t("sales-price")}`}
              rules={[{ required: true, message: "seles is requried" }]}
            >
              <Input
                placeholder={`${t("enter-text")}`}
                autoComplete="off"
                maxLength={15}
              />
            </Form.Item>
          </Col>

          <Col offset={2} span={5}>
            <Form.Item name="expirationDate" label={`${t("expiration-date")}`}>
              <DatePicker
                data-testid="date"
                placeholder={`${t("MM/DD/YYYY")}`}
                format={"MM/DD/YYYY"}
                style={{ width: "100%" }}
              />
            </Form.Item>
            <Form.Item name="isTaxable" label={`${t("taxable")}`}>
              <Switch
                defaultChecked={isTaxable ?? false}
                checkedChildren={`${t("yes")}`}
                onChange={handleRadioChange}
                unCheckedChildren={`${t("no")}`}
                disabled={true}
              />
            </Form.Item>

            <Form.Item
              name="tax"
              rules={[
                {
                  required: inputEnabled,
                },
              ]}
            >
              <Input
                maxLength={10}
                placeholder={`${t("enter-text")}`}
                autoComplete="off"
                disabled={true}
              />
            </Form.Item>
            <Form.Item name="discountSwitch" label={`${t("discount")}`}>
              <Switch
                defaultChecked={bill?.discount ?? false}
                checkedChildren={`${t("yes")}`}
                unCheckedChildren={`${t("no")}`}
                onChange={handleChange}
                disabled={bill?.discount}
              />
            </Form.Item>

            <Form.Item
              name="discount"
            // label={`${t("discount")}`}
            // rules={[
            //   {
            //     required: discount,
            //   },
            // ]}
            >
              <Input
                addonBefore={selectdiscount}
                maxLength={10}
                disabled={bill?.discount}
                autoComplete="off"
                placeholder={`${t("enter-text")}`}
              />
            </Form.Item>
          </Col>
          <Col offset={2} span={5}>
            <Form.Item name="notes" label={`${t("notes")}`}>
              <TextArea
                autoComplete="off"
                className="scrollable-textarea"
                data-testid="description-input"
                placeholder={`${t("enter-text")}`}
                autoSize={{ minRows: 4, maxRows: 4 }}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="primary"
              className="btn"
              size="large"
              onClick={() => {
                setOpen(true);
              }}
            >
              {isEdit() ? `${t("save")}` : `${t("add")}`}
            </Button>
          </Col>
        </Col>
      </Row>
      <AddEditModal
        form="itembillform"
        open={open}
        setOpen={setOpen}
        name={<span> {item?.item?.name}</span>}
        title={`${t("item bill")}`}
        isSaving={isSaving}
      />
    </>
  );
}

export default AddEditBillItemBill;
